
export { useOddsView } from "/Users/dappweb/Documents/GitHub/Azuro-protocol/example-app/src/contexts/oddsView/index.tsx"